import type { FC } from "react";

import { WWOAdIntelTopPublishersTable } from "app/pages/website-performance/components/TopPublishers/WWOAdIntelTopPublishersTable";

interface IWWOTopPublishersTableContainerProps {
    getCtaLink: () => { href: string; target: string };
    unlockHook?: unknown;
    hideFooter?: boolean;
}

export const WWOTopPublishersTableContainer: FC<IWWOTopPublishersTableContainerProps> = ({
    getCtaLink,
    unlockHook,
    hideFooter = false,
}) => {
    return (
        <WWOAdIntelTopPublishersTable
            getCtaLink={getCtaLink}
            unlockHook={unlockHook}
            hideFooter={hideFooter}
        />
    );
};
